export default "__VITE_ASSET__H2p52zqz__"